export default function Audio(props: any) {
    return (
        <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_9728_20326)">
                <path
                    d="M24.75 27.5625L24.75 8.4375C24.75 7.50552 23.9945 6.75 23.0625 6.75L12.9375 6.75C12.0055 6.75 11.25 7.50552 11.25 8.4375L11.25 27.5625C11.25 28.4945 12.0055 29.25 12.9375 29.25L23.0625 29.25C23.9945 29.25 24.75 28.4945 24.75 27.5625Z"
                    stroke="black"
                    stroke-width="1.35"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path d="M27 21.0188V14.8135" stroke="black" stroke-width="1.35" stroke-miterlimit="10" stroke-linecap="round" />
                <path d="M4.5 21.0188V14.8135" stroke="black" stroke-width="1.35" stroke-miterlimit="10" stroke-linecap="round" />
                <path d="M29.25 23.4448V12.375" stroke="black" stroke-width="1.35" stroke-miterlimit="10" stroke-linecap="round" />
                <path d="M6.75 23.4448V12.375" stroke="black" stroke-width="1.35" stroke-miterlimit="10" stroke-linecap="round" />
                <path d="M31.5 21.258V14.9312" stroke="black" stroke-width="1.35" stroke-miterlimit="10" stroke-linecap="round" />
                <path d="M9 21.258V14.9312" stroke="black" stroke-width="1.35" stroke-miterlimit="10" stroke-linecap="round" />
                <circle cx="18" cy="18" r="2.25" stroke="black" stroke-width="1.35" />
                <circle cx="18" cy="18" r="4.5" stroke="black" stroke-width="1.35" />
            </g>
            <defs>
                <clipPath id="clip0_9728_20326">
                    <rect width="36" height="36" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
}
